var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-my-demo row-container"},[(_vm.$store.state.currentLanguage.id==0)?_c('GetMyDemoZh'):_c('GetMyDemoEn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }